/* eslint-disable no-underscore-dangle */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IFilteredMediaData,
  IMediaItemData,
  IPaginateFilterPayload,
  MediaModalState,
} from './interface';
import { IContentDocument } from '../add-content-modal/interface';

export const initialState: MediaModalState = {
  loading: false,
  mediaResult: {
    result: [],
    total: 0,
  },
};

export const mediaModalSlice = createSlice({
  name: 'feature/common/media-modal',
  initialState,
  reducers: {
    fetchMedia(state: MediaModalState, action: PayloadAction<IPaginateFilterPayload>) {
      state.loading = true;
    },
    fetchMediaSucceeded(state: MediaModalState, action: PayloadAction<IFilteredMediaData>) {
      state.loading = false;
      state.mediaResult = {
        result: action.payload.result
          .filter((media: IMediaItemData) => media.fileCategory.toLowerCase() !== 'folder')
          .map((item: any) => ({
            id: item._id,
            title: item.title,
            fileType: item.fileType,
            fileCategory: item.fileCategory,
            thumbnail: item.thumbnail ?? '',
            isExternalFile: item?.isExternalFile ?? false,
            contentUrl: item.contentUrl,
            createdAt: item.createdAt,
          })),
        total: action.payload.total,
      };
    },
    resetFetchMedia(state: MediaModalState) {
      state.mediaResult = {
        result: [],
        total: 0,
      };
    },
    fetchMediaFailed(state: MediaModalState) {
      state.loading = false;
    },
    addUploadedMedia(state: MediaModalState, action: PayloadAction<IContentDocument>) {
      const content = action.payload;
      state.mediaResult = {
        result: [
          {
            id: content._id,
            title: content.title || '',
            fileType: content.fileType || '',
            fileCategory: content.fileCategory || '',
            thumbnail: content.thumbnailUrl || '',
            contentUrl: content.contentUrl || '',
            createdAt: content.createdAt || '',
          },
          ...state.mediaResult.result,
        ],
        total: state.mediaResult.total + 1,
      };
    },
  },
});

export const { actions: mediaModalActions } = mediaModalSlice;
